import React from 'react';
import FontAwesome from 'react-fontawesome';
import PhotoContainer from '../../PhotoContainer';

const Accepts = ({ accepts }) => {
  if (accepts && accepts.length) {
    let names = [];
    accepts.forEach((u) => {
      if (u.user) {
        names.push(u.user.name);
      }
    });
    let nameList = names.join(', ');
    return (
      <div className="change-accept">
        <FontAwesome name="check" />
        {accepts.map(({ user }, i) => (
          <div key={i} className="user-photo">
            <PhotoContainer
              className="photo-container"
              image={user ? user.avatar : ''}
              defaultImg="user"
            />
          </div>
        ))}
        <span className="text-green">{nameList}</span>
        <span>accepted these terms</span>
      </div>
    );
  } else {
    return null;
  }
};

export default Accepts;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/Accepts.js